// Optimized lodash imports - only import what we actually use
import { groupBy, filter, debounce, throttle, cloneDeep, merge, pick, omit } from 'lodash-es';

// Re-export commonly used functions with better names
export { groupBy, filter, debounce, throttle, cloneDeep, merge, pick, omit };
export const groupByItems = groupBy;
export const filterItems = filter;
export const debounceFunction = debounce;
export const throttleFunction = throttle;
export const deepClone = cloneDeep;
export const mergeObjects = merge;
export const pickProperties = pick;
export const omitProperties = omit;
